import React from "react";
import { FormattedMessage } from "react-intl";
import { Grid, Typography } from "@material-ui/core";

import AnimatedCardContent from "../../../AnimatedCardContent.js";
import ContractColumnDateFilter from "../ContractColumnDateFilter.js";
import ContractDurations from "../../../select/ContractDurations.js";
import ContractTypes from "../../../select/ContractTypes.js";
import SelectMultipleUsersByAgent from "../../../select/SelectMultipleUsersByAgent.js";
import SelectContractSituations from "../SelectContractSituations.js";
import { CONTRACT_HIERARCHY_FILTER_KEYS } from "./filterKeys.js";

const ContractsByHierarchyFilter = ({
  currentUser,
  filters,
  updateFilter,
  loadingAgents,
  users,
  loadingUsers,
  errorUsers,
  enableUserSelect,
  defaultSituations
}) => {
  return (
    <AnimatedCardContent>
      <Typography
        variant="h6"
        gutterBottom
      >
        <FormattedMessage id="app.filters" />
      </Typography>

      <Grid container spacing={2}>
        {enableUserSelect && (
          <Grid item xs={12}>
            <SelectMultipleUsersByAgent
              agents={[currentUser]}
              users={users}
              error={errorUsers}
              loading={loadingUsers}
              selectedUsers={filters.users}
              setSelectedUsers={(values) =>
                updateFilter(CONTRACT_HIERARCHY_FILTER_KEYS.USERS, values)
              }
            />
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SelectContractSituations
                contractSituaions={filters.situations}
                defaultSituations={defaultSituations}
                setContractSituations={(values) => updateFilter(CONTRACT_HIERARCHY_FILTER_KEYS.CONTRACT_SITUATIONS, values)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
            >
              <ContractTypes
                value={filters.modalities}
                onChange={(values) => updateFilter(CONTRACT_HIERARCHY_FILTER_KEYS.CONTRACT_MODALITIES, values)}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
            >
              <ContractDurations
                value={filters.durations}
                onChange={(values) => updateFilter(CONTRACT_HIERARCHY_FILTER_KEYS.CONTRACT_DURATIONS, values)}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ContractColumnDateFilter
            column={filters.dateColumn}
            startDate={filters.startDate}
            finalDate={filters.endDate}
            onChangeColumn={(value) => updateFilter(CONTRACT_HIERARCHY_FILTER_KEYS.DATE_COLUMN, value)}
            onStartDateChange={(value) => updateFilter(CONTRACT_HIERARCHY_FILTER_KEYS.START_DATE, value)}
            onFinalDateChange={(value) => updateFilter(CONTRACT_HIERARCHY_FILTER_KEYS.END_DATE, value)}
          />
        </Grid>
      </Grid>
    </AnimatedCardContent>
  );
};

export default ContractsByHierarchyFilter;
